export const OK = 200; // Success
export const CREATED = 201; // Success with result
export const BADREQUEST = 400; // Bad Request
export const UNAUTHORIZED = 401; // Unauthorized 
export const CONFLICT = 409; // Conflict
export const DATANOTFOUND = 404; //Data not found